/* eslint-disable react/jsx-no-useless-fragment */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Drawer } from "@cinch-labs/design-system";
import styles from "./admin-fee-drawer.module.css";
export var AdminFeeDrawer = function(param) {
    var showAdminFeeDrawer = param.showAdminFeeDrawer, onClose = param.onClose;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: showAdminFeeDrawer && /*#__PURE__*/ _jsx(Drawer, {
            onClose: onClose,
            header: "Admin Fee",
            ariaLabelledById: "admin-fee-drawer",
            children: /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.paragraph,
                        children: "The \xa399 admin fee powers your faff-free customer experience, including administration costs associated with processing your car."
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.paragraph,
                        children: "If you return your car using our 14-day money-back guarantee, we’ll give you a full refund, including the \xa399 admin fee."
                    })
                ]
            })
        })
    });
};
